import ITeam, { TimeParmDTO } from '@/interfaces/teams';
import ClientUnitModel from './client-unit-model';
import IDoctor from '@/interfaces/doctor';
import { toUpperCase } from '@/helpers/toUpperCase';

export default class TeamModel {
  public id: string;
  public codigo: string;
  public nome: string;
  public ativo: boolean;
  public unidade: ClientUnitModel;
  public medicos: IDoctor[];

  constructor(_initialValues?: ITeam) {
    const initialValues = _initialValues || {
      id: '',
      codigo: '',
      nome: '',
      ativo: true,
      unidade: new ClientUnitModel(),
      medicos: [],
    };

    this.id = initialValues.id;
    this.codigo = initialValues.codigo;
    this.nome = initialValues.nome;
    this.ativo = initialValues.ativo;
    this.unidade = initialValues.unidade;
    this.medicos = initialValues.medicos;
  }

  public toJson(): ITeam {
    return {
      id: this.id,
      codigo: toUpperCase(this.codigo),
      nome: toUpperCase(this.nome),
      ativo: this.ativo,
      medicos: this.medicos,
      unidade: this.unidade,
    };
  }

  public toTimeParmDTO(): TimeParmDTO {
    return {
      id: this.id? Number(this.id) : null ,
      codigo: toUpperCase(this.codigo),
      nome: toUpperCase(this.nome),
      ativo: this.ativo,
      idsMedicos: this.medicos ? this.medicos.map(m => Number(m.id)) : [],
      idUnidade: this.unidade ? Number(this.unidade.id) : null,
    };
  }
}
